/* =====================================================================
   TydeFlux — interações v7 (sem dependências)
   Galeria, seletor de kits, sanfonas animadas, carrossel, linha do tempo,
   contadores, barra fixa de compra, topo com progresso e seção ativa.
   Cada módulo roda isolado: se um falhar, os outros continuam.
   Não intercepta cliques de compra — o rastreio (bb-tracker / PostHog) segue intacto.
   ===================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function run(name, fn) { try { fn(); } catch (e) { if (window.console) console.warn('[tf] ' + name, e); } }

  /* ---------- Revelar ao rolar ---------- */
  run('reveal', function () {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('tf-js');
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      fired = true;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
    // trava de segurança: se o navegador não reportar a rolagem (robôs, webviews), mostra tudo
    setTimeout(function () {
      if (fired) return;
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 2500);
  });

  /* ---------- Topo: sombra, progresso, seção ativa + barra fixa ---------- */
  run('scroll', function () {
    var header = $('[data-tf-header]');
    var progress = $('[data-tf-progress]');
    var links = $$('[data-tf-nav]');
    var targets = links.map(function (a) { return doc.getElementById((a.getAttribute('href') || '').replace('#', '')); });
    var sticky = $('[data-tf-sticky]');
    var stickyAnchor = $('[data-tf-sticky-after]');
    var stickyStop = $$('[data-tf-sticky-stop]');
    var ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset || root.scrollTop || 0;
      var vh = window.innerHeight;
      var max = Math.max(1, root.scrollHeight - vh);

      if (header) header.classList.toggle('is-scrolled', y > 8);
      if (progress) progress.style.setProperty('--p', Math.min(1, Math.max(0, y / max)).toFixed(4));

      if (links.length) {
        var active = -1;
        var best = -Infinity;
        targets.forEach(function (t, i) {
          if (!t) return;
          var top = t.getBoundingClientRect().top;
          if (top < vh * 0.35 && top > best) { best = top; active = i; }
        });
        links.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
      }

      if (sticky && stickyAnchor) {
        var passed = stickyAnchor.getBoundingClientRect().bottom < 0;
        var blocked = stickyStop.some(function (el) {
          var r = el.getBoundingClientRect();
          return r.top < vh && r.bottom > 0;
        });
        var show = passed && !blocked;
        if (show !== sticky.classList.contains('is-visible')) {
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  /* ---------- Galeria ---------- */
  run('gallery', function () {
    $$('[data-tf-gallery]').forEach(function (g) {
      var track = $('[data-tf-track]', g);
      if (!track) return;
      var slides = $$('[data-tf-slide]', g);
      var thumbs = $$('[data-tf-thumb]', g);
      var dots = $$('[data-tf-dot]', g);
      var current = 0;
      var timer;

      function setActive(i) {
        current = i;
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        var t = thumbs[i];
        var box = t && t.parentNode;
        if (box && box.scrollWidth > box.clientWidth + 2) {
          box.scrollTo({ left: t.offsetLeft - (box.clientWidth - t.clientWidth) / 2, behavior: 'smooth' });
        }
      }
      function goTo(i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
      var prev = $('[data-tf-prev]', g);
      var next = $('[data-tf-next]', g);
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      track.addEventListener('scroll', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          i = Math.max(0, Math.min(slides.length - 1, i));
          if (i !== current) setActive(i);
        }, 70);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      setActive(0);
    });
  });

  /* ---------- Seletor de kits ----------
     Cada card ([data-tf-bundle]) carrega os dados do kit. Ao escolher, o botão principal
     recebe o link do kit (href) e o data-bb-pack — é isso que o bb-tracker lê no clique. */
  run('bundles', function () {
    $$('[data-tf-bundles]').forEach(function (box) {
      var cards = $$('[data-tf-bundle]', box);
      if (!cards.length) return;
      var scope = box.closest('[data-tf-offer]') || doc;
      var cta = $('[data-tf-cta]', scope);

      function setAll(sel, value) {
        $$(sel).forEach(function (el) { el.textContent = value || ''; });
      }
      function apply(card, animate) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-selected', on);
          var input = $('input', c);
          if (input) input.checked = on;
        });
        var d = card.dataset;
        if (cta) {
          if (d.href && cta.tagName === 'A') cta.setAttribute('href', d.href);
          if (d.pack) cta.setAttribute('data-bb-pack', d.pack);
          var label = $('[data-tf-cta-label]', cta);
          var price = $('[data-tf-cta-price]', cta);
          var compare = $('[data-tf-cta-compare]', cta);
          if (label && d.cta) label.textContent = d.cta;
          if (price) price.textContent = d.price || '';
          if (compare) compare.textContent = d.compare || '';
          if (cta.tagName === 'BUTTON') cta.disabled = card.classList.contains('is-soldout');
          if (animate) { cta.classList.remove('is-bump'); void cta.offsetWidth; cta.classList.add('is-bump'); }
        }
        setAll('[data-tf-sticky-name]', d.name);
        setAll('[data-tf-sticky-price]', d.price);
        setAll('[data-tf-sticky-compare]', d.compare);
        var cardImg = $('img', card);
        if (cardImg) $$('[data-tf-sticky-img]').forEach(function (el) { el.src = cardImg.currentSrc || cardImg.src; });
        if (animate) { card.classList.remove('is-pop'); void card.offsetWidth; card.classList.add('is-pop'); }
      }
      cards.forEach(function (c) {
        var input = $('input', c);
        if (!input) return;
        input.addEventListener('change', function () { if (input.checked) apply(c, true); });
      });
      var initial = cards.filter(function (c) { var i = $('input', c); return i && i.checked; })[0] || cards[0];
      apply(initial, false);
    });
  });

  /* ---------- Sanfonas com altura animada ---------- */
  run('accordion', function () {
    var canAnimate = typeof Element !== 'undefined' && 'animate' in Element.prototype;
    $$('details[data-tf-acc]').forEach(function (det) {
      var sum = $('summary', det);
      if (!sum || !canAnimate) return;
      var anim = null;
      var guard = 0;
      function finishClose() { clearTimeout(guard); det.open = false; det.classList.remove('is-closing'); anim = null; }
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(guard);
        if (anim) { anim.cancel(); anim = null; }
        var startH = det.offsetHeight;
        if (det.open && !det.classList.contains('is-closing')) {
          det.classList.add('is-closing');
          anim = det.animate({ height: [startH + 'px', sum.offsetHeight + 'px'] }, { duration: 340, easing: 'cubic-bezier(.2,.8,.2,1)' });
          anim.onfinish = finishClose;
          // se a animação não terminar (aba em segundo plano etc.), fecha assim mesmo
          guard = setTimeout(function () { if (anim) { anim.cancel(); finishClose(); } }, 600);
        } else {
          det.classList.remove('is-closing');
          det.open = true;
          var endH = det.offsetHeight;
          anim = det.animate({ height: [startH + 'px', endH + 'px'] }, { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
          anim.onfinish = function () { anim = null; };
        }
      });
    });
  });

  /* ---------- Carrossel (depoimentos) ---------- */
  run('carousel', function () {
    $$('[data-tf-carousel]').forEach(function (c) {
      var track = $('[data-tf-ctrack]', c);
      if (!track) return;
      var prev = $('[data-tf-cprev]', c);
      var next = $('[data-tf-cnext]', c);
      var bar = $('[data-tf-cbar]', c);
      function step() {
        var first = track.children[0];
        var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
        return first ? first.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (bar) {
          bar.style.setProperty('--w', Math.min(100, track.clientWidth / Math.max(1, track.scrollWidth) * 100).toFixed(2) + '%');
          bar.style.setProperty('--x', max > 0 ? (track.scrollLeft / max).toFixed(4) : 0);
        }
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  });

  /* ---------- Linha do tempo com gráfico ----------
     Cada aba tem data-x (posição no eixo, em unidades do viewBox). O marcador corre pela curva
     até esse x; a bolha fica ao lado do marcador; rótulos do eixo são HTML (não encolhem no celular). */
  run('timeline', function () {
    $$('[data-tf-timeline]').forEach(function (tl) {
      var tabs = $$('[data-tf-tab]', tl);
      var panels = $$('[data-tf-panel]', tl);
      var path = $('[data-tf-curve]', tl);
      var marker = $('[data-tf-marker]', tl);
      var bubble = $('[data-tf-bubble]', tl);
      var labels = $$('[data-tf-xlabel]', tl);
      var svg = path && path.ownerSVGElement;
      if (!tabs.length || !path || !svg) return;

      var vb = svg.viewBox.baseVal;
      var len = path.getTotalLength();
      function fracForX(x) {
        var lo = 0, hi = len;
        for (var n = 0; n < 26; n++) {
          var mid = (lo + hi) / 2;
          if (path.getPointAtLength(mid).x < x) lo = mid; else hi = mid;
        }
        return lo / len;
      }
      var stops = tabs.map(function (t) { return fracForX(parseFloat(t.getAttribute('data-x')) || 0); });
      var pos = 0;
      var raf = 0;
      var auto = null;
      var current = -1;

      path.style.strokeDasharray = len + ' ' + len;

      function place(f) {
        var p = path.getPointAtLength(len * f);
        path.style.strokeDashoffset = (len * (1 - f)).toFixed(1);
        if (marker) marker.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')');
        if (bubble && vb && vb.width) {
          bubble.style.left = (p.x / vb.width * 100).toFixed(2) + '%';
          bubble.style.top = (p.y / vb.height * 100).toFixed(2) + '%';
          bubble.classList.toggle('is-left', f > 0.32);
          bubble.classList.toggle('is-low', p.y / vb.height > 0.62);
        }
      }
      function animateTo(f, dur) {
        cancelAnimationFrame(raf);
        var from = pos;
        var t0 = performance.now();
        (function frame(now) {
          var k = Math.min(1, (now - t0) / dur);
          pos = from + (f - from) * easeOut(k);
          place(pos);
          if (k < 1) raf = requestAnimationFrame(frame);
        })(t0);
      }
      function select(i, userAction) {
        if (i === current) return;
        current = i;
        tabs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
          t.tabIndex = k === i ? 0 : -1;
        });
        panels.forEach(function (p, k) {
          p.hidden = k !== i;
          if (k === i) { p.classList.remove('is-in'); void p.offsetWidth; p.classList.add('is-in'); }
        });
        labels.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('data-tf-xlabel') === String(i)); });
        if (bubble) {
          var b = $('b', bubble), s = $('span', bubble);
          if (b) b.textContent = tabs[i].getAttribute('data-bubble') || '';
          if (s) s.textContent = tabs[i].getAttribute('data-bubble-sub') || '';
          bubble.classList.remove('is-pop'); void bubble.offsetWidth; bubble.classList.add('is-pop');
        }
        animateTo(stops[i], userAction ? 750 : 1100);
        if (userAction && auto) { clearInterval(auto); auto = null; }
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { select(k, true); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = (k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[n].focus();
          select(n, true);
        });
      });

      // estado inicial já visível (sem JS de animação o gráfico continua legível)
      select(0, false);
      pos = 0; place(0);
      animateTo(stops[0], 1);

      var userTouched = false;
      tabs.forEach(function (t) { t.addEventListener('click', function () { userTouched = true; }); });
      function startAuto() {
        if (auto || userTouched) return;
        auto = setInterval(function () { select((current + 1) % tabs.length, false); }, 4200);
      }
      function stopAuto() { if (auto) { clearInterval(auto); auto = null; } }
      if ('IntersectionObserver' in window) {
        var first = true;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              if (first) { first = false; pos = 0; place(0); animateTo(stops[current], 1300); }
              startAuto();
            } else {
              stopAuto();
            }
          });
        }, { threshold: 0.35 });
        io.observe(tl);
      }
      window.addEventListener('resize', function () { place(pos); });
    });
  });

  /* ---------- Contadores ---------- */
  run('count', function () {
    var els = $$('[data-tf-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    // o número final fica no HTML; só zera quando o navegador confirma que está fora da tela
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var el = e.target;
        var suffix = el.getAttribute('data-suffix') || '';
        if (!e.isIntersecting) {
          if (!el.__tfArmed) { el.__tfArmed = true; el.textContent = '0' + suffix; }
          return;
        }
        io.unobserve(el);
        if (!el.__tfArmed) return; // já estava visível ao abrir: mantém o número final
        var to = parseFloat(el.getAttribute('data-tf-count')) || 0;
        var t0 = performance.now();
        (function frame(now) {
          var k = Math.min(1, (now - t0) / 1300);
          el.textContent = Math.round(to * easeOut(k)) + suffix;
          if (k < 1) requestAnimationFrame(frame);
        })(t0);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  });
})();
